module.exports = __webpack_public_path__ + "images/icon/icon_16x16_fill_view_list-d4961e18.svg";